// extracted by mini-css-extract-plugin
module.exports = {"dateHeader":"TimelineWrapper_dateHeader__4Gyov"};